module.exports = __webpack_public_path__ + "images/tether-a7af7092c71ff89d4de8ee68884a977b.png";